// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { IPublicClientApplication } from '@azure/msal-browser';
import { Api, FetchBaseQueryError, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { msalInstance } from '../../index';
import { useSnackbarAlert } from 'src/layout/SnackbarAlerts/useSnackbarAlert';

// initialize an empty api service that we'll inject endpoints into later as needed

export const emptySplitApi = createApi({
  reducerPath: 'price',
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env['VITE_API_BASE_URL']}`,
    //sets up authorization

    prepareHeaders: async (headers) => {
      const acquireAccessToken = async (msalInstance: IPublicClientApplication) => {
        const activeAccount = msalInstance.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
        const accounts = msalInstance.getAllAccounts();

        if (!activeAccount && accounts.length === 0) {
          throw 'Error: User not logged in';
        }

        const request = {
          scopes: [`${import.meta.env['VITE_AAD_APP_USER_IMPERSONATION_SCOPE']}`],
          account: activeAccount || accounts[0]
        };

        const authResult = await msalInstance.acquireTokenSilent(request);
        return authResult;
      };

      const authResult = await acquireAccessToken(msalInstance);
      const token = authResult.accessToken;

      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }

      return headers;
    }
  }),

  endpoints: () => ({})
});

export const useEmptyApiErrorEnhancements = (priceApi: Api<any, any, any, any, any>) => {
  const { addToast } = useSnackbarAlert();
  let endpoints: any = {};

  for (const key in priceApi.endpoints) {
    const enhancedEndpoint = {
      [key]: {
        transformErrorResponse: (response: FetchBaseQueryError) => {
          if ('originalStatus' in response) {
            const { originalStatus } = response;
            if (originalStatus >= 500 && originalStatus < 600) {
              addToast({
                title: 'APIM Service',
                message: 'APIM service is down. Consider upgrading tier or wait for service to return.',
                severity: 'error'
              });
            }
          }
        }
      }
    };
    endpoints = {
      ...endpoints,
      ...enhancedEndpoint
    };
  }

  priceApi.enhanceEndpoints({
    endpoints
  });
};
